import { Box, CircularProgress } from '@mui/material';

export default function LoadingScreen() {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '60vh' 
      }}
    >
      <CircularProgress 
        sx={{ 
          color: '#EDAFB8'
        }} 
      />
    </Box>
  );
}